import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgUser extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg viewBox="0 0 45 45" height={size}>
                <g fill={color}>
                    <path d="M39.561 33.971l-.145.174c-4.774 5.728-11.133 8.884-17.902 8.884-6.77 0-13.128-3.155-17.903-8.884l-.144-.174.034-.223c.922-6.014 4.064-10.845 8.847-13.606l.34-.196.271.284c2.259 2.37 5.297 3.674 8.554 3.674s6.295-1.305 8.554-3.674l.271-.284.34.196c4.783 2.761 7.925 7.592 8.848 13.606l.035.223zM21.514 21.489c5.924 0 10.744-4.82 10.744-10.744C32.258 4.821 27.438 0 21.514 0S10.77 4.821 10.77 10.744s4.82 10.745 10.744 10.745z" />
                </g>
            </svg>
        );
    }
}

export default withTheme(SvgUser);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgUser.js